import { DataRegion, RegionDataStores } from '../app/market/market-config';
import { APP_VERSION } from './app-version';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: APP_VERSION,
  /** ONE Firebase project for all countries (D29) – the login of every user lives here. */
  firebase: {
    apiKey: "AIzaSyDYgqDklebBEoOnenSGWuFGACAdirdw_gY",
    authDomain: "kfzdatenbank-56cc5.firebaseapp.com",
    projectId: "kfzdatenbank-56cc5",
    storageBucket: "kfzdatenbank-56cc5.appspot.com",
    messagingSenderId: "1006753986696",
    appId: "1:1006753986696:web:df907503a1c43d78a9873d",
    measurementId: "G-KGJDGKTVBG"
  },
  /** Region of our callable Cloud Functions (R4). */
  functionsRegion: 'europe-west1',
  /** Firestore and Storage per REGION (D30). A new region adds one entry – a new EU country adds none. */
  dataStoresByRegion: {
    eu: {
      firestoreDatabaseId: '(default)',
      storageBucket: 'kfzdatenbank-56cc5.appspot.com',
    },
  } satisfies Record<DataRegion, RegionDataStores>,
  /**
   * Flask API address per MARKET. Both addresses lead to the SAME service (D38): it finds the country of a
   * request in the login, not in the address.
   */
  apiBaseUrlByMarket: {
    de: 'https://api.kfzbook.de/api',
    ie: 'https://api-ie-dev.vehlogs.com/api',
  } satisfies Record<'de' | 'ie', string>,
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
